import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';

@Component({
  selector: 'app-input-text-link',
  templateUrl: './input-text-link.component.html',
  styleUrls: ['./input-text-link.component.scss']
})
export class InputTextLinkComponent extends ComponentBase implements OnInit {

  constructor() {
    super()
  }

  ngOnInit() {
  }

  onMaxlength(event: any, size:number){
    if (event.composedPath.length > size) {
      return false;
    }
  }

  getOptionByKey(attribute: AttributeModel, key: string): string {
    let baseResult = super.getOptionByKey(attribute, key)

    if(baseResult) {
      return baseResult
    }

    return "false"
  }

  onChange(){
    this.emit({ name: "autosave", data: "silently" })
  }

  ngBlurInput(id: string) {
    if ($('#' + id).val() != '')
      $('#' + id).removeClass('has-error');
  }

  ngGetComponentType(attribute: AttributeModel): string {

    if (attribute.type.toLowerCase() == "boolean")
      return "checkbox";
    else if (attribute.type.toLowerCase() == "booleanoexclusivo")
      return "radio";
    else if(attribute.type.toLowerCase() == "number")
      return "number"
    else
      return "text";
  }

  getLabel(): string {
    let label = this.attribute.options.find(o => o.key.toLowerCase() == "label")

    if(label) {
      return label.value
    }

    return this.attribute.key
  }

  getTitle(): string {
    let title = this.attribute.options.find(o => o.key.toLowerCase() == "title")

    if(title) {
      return title.value
    }

    return this.attribute.value
  }

  isLink(): boolean {
    if(this.attribute.value) {
      return this.attribute.value.startsWith("http")
    } else {
      return false
    }
  }
}
